let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dgQcw")).then(() => parcelRequire('22Hs1'));